import axios from 'axios';
import config from '../../config';

class FileUploadHandler {
  constructor(formComponent) {
    this.form = formComponent;
  }

  async uploadFileAndUpdateAnswer(value, reqId) {
    let fileToUpload = [];
    let fileUploaded = [];

    if (
      typeof value.answer[0] === 'string' &&
      value.answer[0].startsWith('https://')
    ) {
      return value.answer[0];
    }

    for (let answerKey of value.answer[0]) {
      if (answerKey instanceof File) {
        fileToUpload.push(answerKey);
      } else {
        fileUploaded.push(answerKey);
      }
    }

    if (fileToUpload && fileToUpload[0]) {
      let obj = await this.zipAndUploadFile(fileToUpload, reqId, value.key);
      fileUploaded.push(...obj['obj_of_file_uploads']);
    }

    return fileUploaded;
  }

  async traverseAndFlatten(currentNode, action, reqId, failedUploads) {
    for (var key in currentNode) {
      if (!currentNode.hasOwnProperty(key)) continue;

      let value = currentNode[key];

      if (!value || !value.format) continue;

      if (value.format == 'esignature_answer' || value.format == 'image_annotation_answer') {
        if (action == 'SAVE') {
          currentNode[key] = { ...value, answer: [value.answer[0]] };
        } else if (action == 'SUBMIT_SESSION') {
          console.log('submit_session');

          if (value && value.answer && value.answer[0]) {
            currentNode[key] = { ...value, answer: [value.answer[0]] };
          }
        } else if (action == 'SUBMIT') {
          if (value && value.answer && value.answer[0]) {
            if (value.answer[0]) {
              currentNode[key] = { ...value, answer: [value.answer[0]] };
            }
          }
        }
      }

      if (value.format == 'upload_media' || value.format == 'file_upload') {
        if (action == 'SAVE' && value.answer && value.answer[0].length > 1) {
          try {
            let fileUploaded = await this.uploadFileAndUpdateAnswer(
              value,
              reqId
            );
            currentNode[key] = { ...value, answer: [fileUploaded] };
          } catch (e) {
            console.log(e);
            if (failedUploads && !(value.key in failedUploads)) {
              failedUploads[value.key] = value;
            }
          }
        } else if (
          action == 'SAVE' &&
          value.answer &&
          value.answer[0][0] instanceof File
        ) {
          try {
            let obj = await this.uploadFile(value.answer[0][0], reqId);
            currentNode[key] = { ...value, answer: [obj] };
          } catch (e) {
            console.log(e);
            if (failedUploads && !(value.key in failedUploads)) {
              failedUploads[value.key] = value;
            }
          }
        }

        if (
          (action == 'SUBMIT' || action == 'SUBMIT_SESSION') &&
          value.answer &&
          value.answer[0].length > 1
        ) {
          try {
            let fileUploaded = await this.uploadFileAndUpdateAnswer(
              value,
              reqId
            );
            currentNode[key] = { ...value, answer: [fileUploaded] };
          } catch (e) {
            console.log(e);
            if (failedUploads && !(value.key in failedUploads)) {
              failedUploads[value.key] = value;
            }
          }
        } else if (
          (action == 'SUBMIT' || action == 'SUBMIT_SESSION') &&
          value.answer
        ) {
          let obj = value.answer[0];
          if (value.answer[0][0] instanceof File) {
            try {
              obj = await this.uploadFile(value.answer[0][0], reqId);
              currentNode[key] = { ...value, answer: [obj] };
            } catch (e) {
              console.log(e);
              if (failedUploads && !(value.key in failedUploads)) {
                failedUploads[value.key] = value;
              }
            }
          }
        }
      }
    }

    return currentNode;
  }

  async uploadFile(files, reqId) {
    const idToken = await this.form.processIdToken();

    if (!Array.isArray(files)) {
      return this.uploadSingleFile(files, reqId, idToken);
    }

    return this.uploadMultipleFiles(files, reqId, idToken);
  }

  async uploadSingleFile(file, reqId, idToken) {
    const formData = this.createFormDataForSingleFile(file, reqId);
    const response = await this.performUploadRequest(formData, idToken);

    return this.createFileUploadResult(response.data[0]);
  }

  async uploadMultipleFiles(files, reqId, idToken) {
    const MAX_BATCH_SIZE = 5 * 1024 * 1024;
    const batches = this.createBatches(files, MAX_BATCH_SIZE);
    const uploadedFiles = [];

    this.logUploadSummary(files.length, batches.length);
    this.logOversizedFiles(files, MAX_BATCH_SIZE);

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];

      try {
        const batchResults = await this.uploadBatch(batch, reqId, idToken);
        uploadedFiles.push(...batchResults);
      } catch (error) {
        console.error(`Batch ${batchIndex + 1} failed:`, error.message);
        throw error;
      }
    }

    if (uploadedFiles.length > 0) {
      return this.createFileUploadResult(uploadedFiles[0]);
    }
  }

  createFormDataForSingleFile(file, reqId) {
    const formData = new FormData();
    formData.append('file', file);
    this.appendFormMetadata(formData, reqId);
    return formData;
  }

  createFormDataForBatch(files, reqId) {
    const formData = new FormData();

    for (const file of files) {
      formData.append('file', file);
    }

    this.appendFormMetadata(formData, reqId);
    return formData;
  }

  appendFormMetadata(formData, reqId) {
    formData.append('formSessionId', this.form.props.match.params.session_id);
    formData.append('formId', this.form.props.match.params.form_id);
    formData.append(
      'projectSessionId',
      this.form.state.projectSessionId || reqId
    );
    formData.append('projectId', this.form.state.projectId);
    formData.append('projectVersion', this.form.state.projectVersion);
  }

  async performUploadRequest(formData, idToken) {
    return await axios.post(`${config.API_ADDRESS}/form_upload`, formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        Authorization: idToken,
      },
      timeout: 300000,
    });
  }

  createFileUploadResult(fileData) {
    return {
      id: fileData.id,
      name: fileData.fileName,
      link: `${config.FILE_ADDRESS}/${fileData.id}`,
    };
  }

  createBatches(files, maxBatchSize) {
    const batches = [];
    let currentBatch = [];
    let currentBatchSize = 0;

    for (const file of files) {
      if (this.isFileOversized(file, maxBatchSize)) {
        this.finalizeCurrentBatch(batches, currentBatch);
        batches.push([file]);
        currentBatch = [];
        currentBatchSize = 0;
        continue;
      }

      if (
        this.wouldExceedBatchSize(currentBatchSize, file.size, maxBatchSize) &&
        currentBatch.length > 0
      ) {
        batches.push(currentBatch);
        currentBatch = [file];
        currentBatchSize = file.size;
      } else {
        currentBatch.push(file);
        currentBatchSize += file.size;
      }
    }

    this.finalizeCurrentBatch(batches, currentBatch);
    return batches;
  }

  isFileOversized(file, maxBatchSize) {
    return file.size > maxBatchSize;
  }

  wouldExceedBatchSize(currentSize, fileSize, maxBatchSize) {
    return currentSize + fileSize > maxBatchSize;
  }

  finalizeCurrentBatch(batches, currentBatch) {
    if (currentBatch.length > 0) {
      batches.push(currentBatch);
    }
  }

  logUploadSummary(fileCount, batchCount) {
    console.log(`Uploading ${fileCount} files in ${batchCount} batches`);
  }

  logOversizedFiles(files, maxBatchSize) {
    const oversizedFiles = files.filter((file) => file.size > maxBatchSize);

    if (oversizedFiles.length > 0) {
      const maxSizeInMB = maxBatchSize / (1024 * 1024);
      const oversizedFileDetails = oversizedFiles.map(
        (file) => `${file.name} (${(file.size / (1024 * 1024)).toFixed(2)}MB)`
      );

      console.warn(
        `Found ${oversizedFiles.length} files larger than ${maxSizeInMB}MB:`,
        oversizedFileDetails
      );
    }
  }

  async uploadBatch(files, reqId, idToken) {
    const formData = this.createFormDataForBatch(files, reqId);
    const response = await this.performUploadRequest(formData, idToken);

    if (response && response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  }

  async zipAndUploadFile(files, reqId, zipName) {
    const idToken = await this.form.processIdToken();

    if (!Array.isArray(files)) {
      return this.uploadSingleZipFile(files, reqId, zipName, idToken);
    }

    return this.uploadMultipleZipFiles(files, reqId, zipName, idToken);
  }

  async uploadSingleZipFile(file, reqId, zipName, idToken) {
    const formData = this.createFormDataForSingleZipFile(file, reqId, zipName);
    const response = await this.performUploadRequest(formData, idToken);

    return this.createZipUploadResult(response.data);
  }

  async uploadMultipleZipFiles(files, reqId, zipName, idToken) {
    const MAX_BATCH_SIZE = 5 * 1024 * 1024;
    const batches = this.createBatches(files, MAX_BATCH_SIZE);
    const uploadedFiles = [];

    this.logZipUploadSummary(files.length, batches.length);
    this.logOversizedFiles(files, MAX_BATCH_SIZE);

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];

      try {
        const batchResults = await this.uploadZipBatch(
          batch,
          reqId,
          zipName,
          idToken
        );
        uploadedFiles.push(...batchResults);
      } catch (error) {
        console.error(`Batch ${batchIndex + 1} failed:`, error.message);
        throw error;
      }
    }

    if (uploadedFiles.length > 0) {
      return this.createZipUploadResult(uploadedFiles);
    }
  }

  createFormDataForSingleZipFile(file, reqId, zipName) {
    const formData = new FormData();
    formData.append('file', file);
    this.appendFormMetadata(formData, reqId);
    formData.append('zipName', zipName);
    return formData;
  }

  createFormDataForZipBatch(files, reqId, zipName) {
    const formData = new FormData();

    for (const file of files) {
      formData.append('file', file);
    }

    this.appendFormMetadata(formData, reqId);
    formData.append('zipName', zipName);
    return formData;
  }

  createZipUploadResult(fileDataArray) {
    const fileUploads = [];

    for (const fileData of fileDataArray) {
      const fileUpload = {
        id: fileData.id,
        name: fileData.fileName,
        link: `${config.FILE_ADDRESS}/${fileData.id}`,
      };
      fileUploads.push(fileUpload);
    }

    return {
      obj_of_file_uploads: fileUploads,
    };
  }

  logZipUploadSummary(fileCount, batchCount) {
    console.log(
      `Uploading ${fileCount} files in ${batchCount} batches for zip`
    );
  }

  async uploadZipBatch(files, reqId, zipName, idToken) {
    const formData = this.createFormDataForZipBatch(files, reqId, zipName);
    const response = await this.performUploadRequest(formData, idToken);

    if (response && response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  }
}

export default FileUploadHandler;
